export const en = {
  // Theme
  theme: {
    switchToLight: 'Light Theme',
    switchToDark: 'Dark Theme',
    switchToLightTooltip: 'Switch to light theme',
    switchToDarkTooltip: 'Switch to dark theme'
  },

  // Navigation Menu
  nav: {
    menu: 'Menu',
    home: 'Home',
    about: 'About Us',
    news: 'News',
    careers: 'Careers',
    investor: 'Investor Relations',
    contact: 'Contact Us'
  },

  // Header
  header: {
    supplierService: 'Supplier Service',
    drugTestQuery: 'Drug Test Query'
  },

  // Navigation
  navigation: {
    home: 'Home',
    about: 'About Us',
    aboutCompany: 'Company Profile',
    aboutHistory: 'Our History',
    aboutHonors: 'Honors & Certifications',
    aboutOrganization: 'Organization',
    aboutTeam: 'Our People',
    aboutLogistics: 'Logistics Center',
    aboutCulture: 'Corporate Culture',
    news: 'News',
    careers: 'Careers',
    careersRecruitment: 'Social Recruitment',
    careersSocial: 'Social Recruitment',
    careersCampus: 'Campus Recruitment',
    investor: 'Investor Relations',
    investorService: 'Investor Service',
    stockInfo: 'Stock Information',
    investorAnnouncements: 'Announcements & Circulars',
    investorFinancialReports: 'Financial Reports',
    investorGovernance: 'Corporate Governance',
    investorInquiry: 'Investor Inquiry',
    investorContact: 'Investor Contact',
    announcements: 'Announcements & Circulars',
    contact: 'Contact Us'
  },

  // Customer Service
  customerService: {
    title: 'Customer Service',
    welcome: 'Hello! How can we help you today?',
    phone: 'Call Us',
    email: 'Email Us'
  },

  // Home Page
  home: {
    carousel: {
      ariaLabel: 'Home hero carousel'
    },
    about: {
      title: 'About Changmei',
      description: 'Founded in 2000, Changmei Pharmaceutical (Stock Code: 2289.HK) is a leading modern pharmaceutical supply chain service provider in South China. The company focuses on the non-tender pharmaceutical market, with pharmaceutical distribution as its core business, integrating pharmaceutical consulting, third-party logistics and marketing services. Relying on four modern pharmaceutical logistics centers, advanced information management systems and efficient self-operated distribution systems, we provide customers with safe, agile and integrated supply chain solutions.'
    },
    statsGrid: {
      title: 'Becoming the Most Competitive Service Provider in China\'s Pharmaceutical Health Industry',
      primaryDistribution: 'Over 80% primary distribution products',
      experience: 'Years of industry experience',
      suppliers: 'Partner suppliers',
      products: 'Active SKUs',
      customers: 'Terminal customers',
      logisticsCenters: 'Smart logistics centers',
      warehouseArea: 'sqm of modern warehouse space',
      vehicles: 'Distribution vehicles'
    },
    advantages: {
      title: 'Core Advantages',
      marketing: {
        title: 'Go-to-market Leadership',
        items: [
          {
            label: 'Deep Channel Resources',
            content: 'Gathering over 1,500 suppliers with 10+ years of stable cooperation foundation, operating over 15,000 SKUs with 80% primary distribution, serving as core strategic partners for many well-known OTC brands in the Guangdong market.'
          },
          {
            label: 'Extensive Customer Network',
            content: 'Over 10,000 terminal customers with full provincial coverage, radiating to neighboring provinces such as Fujian, Guangxi, Hainan, and Hunan, maintaining a leading position in the non-tender pharmaceutical market in South China.'
          },
          {
            label: 'Senior Professional Team',
            content: 'Core team with over 20 years of industry experience, committed to internal cultivation, deeply understanding customer needs, providing precise and agile personalized marketing solutions and efficient implementation services.'
          },
          {
            label: 'Outstanding Industry Position',
            content: 'The only large pharmaceutical distribution enterprise in the industry completely focused on non-tender market business; ranked among "Top 35 National Pharmaceutical Circulation Industry Wholesale Enterprises" and "Top 500 Guangdong Enterprises" for over 10 consecutive years.'
          },
          {
            label: 'Innovative Business Model',
            content: 'Breaking through traditional multi-channel distribution model, building an integrated "distribution + warehousing + delivery" service system; achieving direct supply from primary agents to terminals through channel sinking, and building the proprietary B2B e-commerce platform "Changmei e-Pharma" to create an omni-channel marketing ecosystem integrating online and offline.'
          }
        ]
      },
      logistics: {
        title: 'Smart Logistics',
        items: [
          {
            label: 'Solid Infrastructure',
            content: 'Owning 4 modern pharmaceutical logistics centers with total warehouse area exceeding 100,000㎡; equipped with over 200 self-owned transport vehicles (cold chain vehicles accounting for over 80%), supporting "multi-variety, small-batch, high-frequency" delivery needs, achieving "three deliveries per day within 10km radius, two deliveries per day within 50km, one delivery per day within 250km".'
          },
          {
            label: 'Intelligent Technology Driven',
            content: 'Integrating AS/RS automated warehouse, EWM/WCS/TMS and other intelligent management systems, combined with Beidou real-time positioning and temperature/humidity monitoring, achieving full automation and visualization of warehouse management, transportation scheduling and operations, ensuring efficiency, accuracy and full control.'
          },
          {
            label: 'Third-party Logistics Benchmark',
            content: 'First in Guangdong Province to pass the new pharmaceutical third-party logistics enterprise inspection certification, innovatively practicing B2B2C integrated warehouse-delivery model, providing customers with compliant and professional pharmaceutical supply chain solutions.'
          },
          {
            label: 'Industry Standard Leadership',
            content: 'Participated in drafting the new version of "Drug Logistics Service Specification" national standard (GB/T 30335-2023), empowering industry standard formulation with Changmei practical wisdom, setting professional benchmarks.'
          }
        ]
      },
      digital: {
        title: 'Digital Intelligence',
        items: [
          {
            label: 'Intelligent Distribution System',
            content: 'Fully introducing innovative technologies such as cloud computing, big data, artificial intelligence, 5G and IoT, deeply integrating business scenarios, GSP control and logistics services to build an integrated pharmaceutical supply chain ecosystem.'
          },
          {
            label: 'Digital Platform Foundation',
            content: 'Self-built and operated "Changmei e-Pharma" B2B e-commerce platform, integrating application tools such as electronic prescriptions, electronic first-time business, automatic warehousing, providing full-process digital solutions for pharmaceutical transactions.'
          },
          {
            label: 'AI Full-domain Empowerment',
            content: 'Promoting full-process informatization, marketing AI assistance, RPA automatic process robot office, achieving supply chain full-process service automation, decision-making data-driven, and intelligent operations.'
          }
        ]
      },
      quality: {
        title: 'Quality Control',
        items: [
          {
            label: 'Company-wide Quality Culture',
            content: 'Adhering to the "Quality First, Prevention First, Full Participation" policy, integrating quality awareness into the corporate culture.'
          },
          {
            label: 'Full-process Traceability System',
            content: 'Establishing a comprehensive quality management system, achieving full-process traceability and tracking of drug procurement, storage, sales and transportation, ensuring clear and transparent circulation chain.'
          },
          {
            label: 'Strict Execution at All Times',
            content: 'Implementing normalized quality control exceeding GSP standards, combining regular inspections with surprise inspections, continuously strengthening quality supervision, and maintaining safety bottom line.'
          }
        ]
      }
    },
    news: {
      title: 'Company News',
      subtitle: 'Stay informed about Changmei\'s latest developments and important events',
      viewAll: 'View All News'
    },
    partners: {
      title: 'Our Partners',
      subtitle: 'Collaborating with leading global companies to create a better future'
    }
  },

  // About Page
  about: {
    hero: {
      title: 'About Changmei',
      subtitle: 'Focused on pharmaceutical distribution, protecting human health'
    },
    company: {
      hero: {
        title: 'Company Profile',
        subtitle: 'Focused on pharmaceutical distribution, serving healthy China'
      },
      intro: {
        title: 'About Changmei',
        content: 'Founded in 2000, Changmei Pharmaceutical (Stock Code: 02289.HK) has been deeply cultivating the pharmaceutical distribution market, continuously strengthening its pharmaceutical distribution business, and actively expanding value-added services such as third-party logistics. With business coverage fully spanning Guangdong and extending to Fujian, Guangxi, and Hainan provinces, and relying on four efficient and coordinated modern pharmaceutical logistics centers, the company provides customers with precisely tailored integrated supply chain solutions. It has become a leading modern pharmaceutical supply chain comprehensive service provider in South China.'
      },
      missionVision: {
        title: 'Mission & Vision',
        mission: {
          title: 'Our Mission',
          slogan: 'Creating Healthy and Beautiful Life',
          content: 'To serve as the health guardian for hundreds of millions of Chinese families, ensuring the efficiency and reliability of the pharmaceutical supply chain.'
        },
        vision: {
          title: 'Our Vision',
          slogan: 'Becoming the Most Competitive Service Provider in China\'s Pharmaceutical Health Industry',
          content: 'To lead the innovative development of China\'s pharmaceutical health industry and supply chain, becoming the most trusted preferred partner in the pharmaceutical health field.'
        }
      },
      mission: {
        title: 'Our Mission',
        content: 'To serve as the health guardian for hundreds of millions of Chinese families, ensuring the efficiency and reliability of the pharmaceutical supply chain.'
      },
      vision: {
        content: 'To lead the innovative development of China\'s pharmaceutical health industry and supply chain, becoming the most trusted preferred partner in the pharmaceutical health field.'
      },
      culture: {
        title: 'Corporate Culture',
        coreValues: {
          title: 'Core Values'
        },
        spirit: {
          title: 'Corporate Spirit',
          content: 'Pragmatic progress, joyful struggle'
        },
        businessPhilosophy: {
          title: 'Business Philosophy',
          content: 'Honest operation, altruism, win-win cooperation'
        },
        servicePhilosophy: {
          title: 'Service Philosophy',
          content: 'Sincere service, wholehearted dedication'
        },
        employeePhilosophy: {
          title: 'Employee Philosophy',
          content: 'Respect, care, kindness, cultivation'
        },
        employeeImage: {
          title: 'Employee Image',
          content: 'Vitality, sincerity, efficiency, truth-centered'
        },
        workPhilosophy: {
          title: 'Work Philosophy',
          content: 'Resilience, responsibility, cooperation, efficiency'
        }
      },
      values: {
        title: 'Core Values',
        innovation: {
          title: 'Innovation',
          description: 'Continuous innovation, leading industry development'
        },
        quality: {
          title: 'Quality',
          description: 'Pursuing excellent quality, ensuring drug safety'
        },
        integrity: {
          title: 'Integrity',
          description: 'Honest operation, winning customer trust'
        },
        collaboration: {
          title: 'Collaboration',
          description: 'Team collaboration, creating value together'
        }
      }
    },
    history: {
      hero: {
        title: 'Our History',
        subtitle: '25 years of forging ahead, building industry benchmarks'
      },
      title: 'Our History',
      subtitle: 'Since establishment, Changmei Pharmaceutical has always adhered to professional development, continuously improving pharmaceutical distribution service system',
      intro: 'Having cultivated the non-tender pharmaceutical market for many years, from an industry newcomer to a leading modern pharmaceutical supply chain service provider in South China, Changmei Pharmaceutical\'s growth and transformation stems from a journey of pioneering and enterprising development.',
      timeline: {
        title: 'Key Milestones'
      },
      1999: {
        title: 'Preparation Phase',
        description: 'Changmei Pharmaceutical began preparation, laying the foundation for development.'
      },
      2005: {
        title: 'Business Expansion',
        description: 'Established the first modern distribution center, expanded business to cover all of Guangdong Province, and established partnerships with many well-known pharmaceutical companies.'
      },
      2010: {
        title: 'Regional Layout',
        description: 'Established branches in Fujian and Guangxi, forming a distribution network across three South China provinces, becoming an important pharmaceutical distribution enterprise in the region.'
      },
      2015: {
        title: 'Smart Upgrade',
        description: 'Invested in building modern logistics center, introduced advanced warehouse management system, improved distribution efficiency and service quality.'
      },
      2020: {
        title: 'Digital Transformation',
        description: 'Comprehensive digital transformation, established intelligent supply chain management system, using big data technology to improve operational efficiency.'
      },
      2024: {
        title: 'Service Innovation',
        description: 'Established the fourth distribution center in Hainan, achieving full coverage of four South China provinces, continuously innovating service models and improving customer experience.'
      }
    },
    team: {
      title: 'Management Team',
      subtitle: 'Gathering industry elites, building professional teams, providing strong talent support for enterprise development',
      members: {
        ceo: {
          name: 'Zhang Minghua',
          position: 'Chairman & CEO',
          bio: 'Medical Doctor with 20 years of pharmaceutical industry experience, formerly worked at several well-known pharmaceutical companies, with rich experience in drug development and corporate management.'
        },
        cto: {
          name: 'Li Xuemei',
          position: 'Chief Technology Officer',
          bio: 'Doctor of Pharmacy, internationally renowned pharmaceutical chemistry expert, led multiple innovative drug development projects, holds over 30 international patents.'
        },
        cfo: {
          name: 'Wang Lijuan',
          position: 'Chief Financial Officer',
          bio: 'MBA, Certified Public Accountant, with rich practical experience in pharmaceutical industry financial management and investment M&A.'
        },
        rdDirector: {
          name: 'Chen Zhiqiang',
          position: 'R&D Director',
          bio: 'Doctor of Biomedical Science, focused on tumor and immunotherapy research for 15 years, led team to complete clinical trials of multiple important projects.'
        },
        marketingDirector: {
          name: 'Liu Xiaoyan',
          position: 'Marketing Director',
          bio: 'Master of Marketing, with deep professional foundation and rich practical experience in pharmaceutical market promotion and brand building.'
        },
        operationsDirector: {
          name: 'Zhao Jianguo',
          position: 'Operations Director',
          bio: 'Master of Engineering, focused on pharmaceutical process optimization and quality management, ensuring production process efficiency and product quality stability.'
        }
      }
    },
    honors: {
      title: 'Honors & Certifications',
      hero: {
        title: 'Honors & Certifications',
        subtitle: 'Professional Certification, Trustworthy'
      },
      intro: 'With the continuous growth of comprehensive strength, Changmei Pharmaceutical\'s brand influence and value have been continuously enhanced. The acquisition of a series of honors demonstrates the company\'s strength and verifies the solid footsteps of the company\'s continuous pursuit of excellence.',
      dataNote: '(Data as of 2025)',
      list: {
        item1: 'Top 500 Guangdong Enterprises',
        years1: '15 consecutive years',
        item2: 'Top 34 National Pharmaceutical Circulation Industry Wholesale Enterprises',
        years2: 'On the Top 100 list for over 14 years',
        item3: 'Best Cold Chain Logistics Center for Pharmaceuticals',
        years3: '6 consecutive years',
        item4: 'Recommended Enterprise for Pharmaceutical Cold Chain Logistics Services',
        years4: '6 consecutive years',
        item5: 'TOP 50 Third-party Modern Pharmaceutical Logistics Service Capability',
        years5: '2 consecutive years',
        item6: 'China Digital Logistics Innovation Application Golden Ant Innovation Award',
        years6: '7 consecutive years',
        item7: 'Modern Pharmaceutical Logistics Technology Experimental Base (Center)',
        years7: '3 consecutive years',
        item8: 'Excellent Pharmaceutical Logistics Distribution Enterprise',
        years8: '4 consecutive years',
        item9: 'Guangdong Province Integrity Business Enterprise',
        years9: '13 consecutive years',
        item10: '2023 Smart Pharmaceutical Supply Chain Integrated Service "Excellent Case Award"',
        item11: '2023 Best Pharmaceutical Marketing Team',
        item12: '2022 China Pharmaceutical Supply Chain Enterprising Enterprise'
      },
      conclusion: 'In the future, guided by the mission of "Creating a Healthy and Better Life", Changmei Pharmaceutical will continue to accelerate its pace, firmly moving towards the goal of becoming "China\'s Most Competitive Service Provider in the Pharmaceutical Health Industry", injecting endless Changmei momentum into the health cause!'
    },
    org: {
      structure: {
        title: 'Organizational Structure'
      },
      board: {
        title: 'Board of Directors',
        name: 'Board of Directors'
      },
      management: {
        title: 'Management'
      },
      ceo: 'General Manager',
      vp: 'Vice General Manager',
      departments: {
        title: 'Functional Departments'
      },
      sales: 'Sales Department',
      procurement: 'Procurement Department',
      logistics: 'Logistics Department',
      quality: 'Quality Management Department',
      finance: 'Finance Department',
      hr: 'Human Resources Department',
      it: 'IT Department',
      admin: 'Administration Department'
    },
    culture: {
      values: {
        title: 'Cultural Philosophy',
        subtitle: 'Changmei Pharmaceutical upholds the corporate culture of "Integrity, Innovation, Professionalism, Win-Win", committed to creating a good working environment for employees, providing quality services to customers, and creating greater value for society.'
      },
      teamwork: {
        title: 'Teamwork',
        desc: 'Unite team strength, create a better future together'
      },
      innovation: {
        title: 'Innovation',
        desc: 'Dare to innovate, pursue excellence'
      },
      customer: {
        title: 'Customer First',
        desc: 'Customer-oriented, providing quality service'
      },
      quality: {
        title: 'Quality First',
        desc: 'Strict quality management, ensuring product safety'
      },
      responsibility: {
        title: 'Social Responsibility',
        desc: 'Undertake social responsibility, give back to society'
      },
      excellence: {
        title: 'Pursue Excellence',
        desc: 'Continuous improvement, pursue excellent quality'
      }
    },
    organization: {
      hero: {
        title: 'Organization',
        subtitle: 'Scientific Management, Efficient Operation'
      },
      pageTitle: 'Organization Structure',
      loading: 'Loading...',
      empty: 'No organization data available'
    },
    teamStyle: {
      hero: {
        title: 'Our People',
        subtitle: 'Professional Team, Create Glory Together'
      },
      intro: {
        title: 'Professional Team · Create Future Together',
        content: 'Changmei Pharmaceutical has a professional and dedicated team. We focus on employee growth and development, providing a good working environment and development platform to create a better future together.'
      },
      highlights: {
        professional: {
          title: 'Professional Team',
          desc: 'Gathering industry elites to build a professional service team'
        },
        growth: {
          title: 'Growth Platform',
          desc: 'Providing comprehensive training system and career development channels'
        },
        care: {
          title: 'Employee Care',
          desc: 'Focusing on employee physical and mental health, creating a warm working atmosphere'
        },
        achievement: {
          title: 'Create Glory Together',
          desc: 'Working hand in hand to create a better future together'
        }
      },
      gallery: {
        title: 'Team Gallery'
      }
    },
    video: {
      company: {
        title: 'Corporate Promotional Video',
        subtitle: 'Learn about Changmei Pharmaceutical\'s development history, corporate culture and service philosophy through video'
      },
      note: 'Note: Please replace the above video link with the actual corporate promotional video'
    },
    logistics: {
      hero: {
        title: 'Logistics Center',
        subtitle: 'Professional Logistics, Safe and Efficient'
      },
      intro: {
        title: 'Logistics Center Introduction',
        content: 'The company owns four modern logistics centers in Shantou, Guangzhou, Shenzhen and Zhuhai, forming an intelligent warehouse cluster with a total area of over 100,000 square meters, equipped with a professional logistics fleet of over 200 vehicles, of which cold chain vehicles account for 80%, fully ensuring the quality of drug storage and transportation. As the first enterprise in Guangdong Province to pass the new third-party pharmaceutical logistics standard certification, the company provides customers with multi-temperature, full-batch, traceable precision logistics services with advanced facilities and management systems.'
      },
      features: {
        title: 'Core Advantages'
      },
      storage: {
        title: 'Modern Warehousing',
        desc: 'Equipped with advanced warehousing facilities to ensure safe drug storage'
      },
      delivery: {
        title: 'Professional Distribution',
        desc: 'Professional cold chain distribution fleet to ensure drug transportation quality'
      },
      quality: {
        title: 'Quality Assurance',
        desc: 'Strict quality management system to ensure drug safety'
      },
      speed: {
        title: 'Quick Response',
        desc: 'Complete delivery within 24 hours to meet customer needs'
      },
      efficiency: {
        title: 'Efficient Operation',
        desc: 'Intelligent management system to improve operational efficiency'
      },
      coverage: {
        title: 'Wide Coverage',
        desc: 'Covering 50+ cities in South China'
      },
      stats: {
        area: 'sqm Warehouse Area',
        vehicles: 'Distribution Vehicles',
        cities: 'Service Cities',
        delivery: 'Delivery Time'
      }
    }
  },

  // News Page
  news: {
    hero: {
      title: 'News & Updates',
      subtitle: 'Stay informed about Changmei\'s latest developments'
    },
    categories: {
      company: 'Company News',
      media: 'Media Coverage'
    },
    readMore: 'Read More',
    relatedNews: 'Related News',
    detail: {
      readTime: 'Reading Time',
      notFound: 'News Not Found',
      notFoundDesc: 'Sorry, the news you are looking for does not exist or has been removed'
    }
  },

  // Careers Page
  careers: {
    backToList: 'Back to List',
    emailSubjectTip: 'Please indicate the position you are applying for in the email subject',
    fetchError: 'Failed to fetch job details',
    jobDescription: 'Job Description',
    jobNotFound: 'Job Not Found',
    noJobs: 'No job openings available',
    requirements: 'Requirements',
    responsibilities: 'Responsibilities',
    sendResumeTo: 'Please send your resume to',
    submitResume: 'Submit Resume'
  },

  // Investor Relations Page
  investor: {
    hero: {
      title: 'Investor Relations',
      subtitle: 'Transparent and timely information disclosure, growing together with investors'
    },
    financialReports: {
      hero: {
        title: 'Financial Reports',
        subtitle: 'Transparent financial information providing comprehensive performance data for investors'
      },
      filter: {
        all: 'All Reports',
        annual: 'Annual Reports',
        interim: 'Interim Reports'
      },
      actions: {
        preview: 'Preview',
        download: 'Download'
      },
      loading: 'Loading...',
      empty: 'No financial reports available',
      pagination: {
        total: 'Total {{total}} items'
      }
    },
    announcements: {
      hero: {
        title: 'Announcements & Circulars',
        subtitle: 'View the latest announcements and circulars'
      },
      sectionTitle: 'Announcements & Circulars',
      yearSuffix: '',
      preview: 'Preview',
      download: 'Download',
      empty: 'No announcements',
      total: 'Total {{total}} items'
    },
    inquiry: {
      hero: {
        title: 'Investor Contact',
        subtitle: 'Convenient contact information and consultation services for investors'
      },
      companyName: 'Charmacy Pharmaceutical Co., Ltd.',
      financialPR: 'Financial PR Company',
      financialPRName: 'Zhixin Financial PR Consulting Co., Ltd.',
      address: 'Address: ',
      phone: 'Phone: ',
      email: 'Email: ',
      postcode: 'Postcode: '
    },
    governance: {
      hero: {
        title: 'Corporate Governance',
        subtitle: 'Standardized and transparent corporate governance structure, protecting shareholder rights'
      },
      tabs: {
        info: 'Corporate Information',
        governance: 'Corporate Governance',
        communication: 'Methods of Disseminating Corporate Communications to Shareholders'
      },
      companyInfo: {
        registeredOffice: 'Registered Office',
        chinaHeadquarters: 'China Headquarters',
        hkPrincipalPlace: 'Hong Kong Principal Place of Business',
        companyWebsite: 'Company Website',
        jointCompanySecretaries: 'Joint Company Secretaries',
        authorizedRepresentatives: 'Authorized Representatives',
        hShareRegistrar: 'H Share Registrar',
        hkCentralSecurities: 'Hongkong Registrars Limited',
        china: 'China',
        guangdong: 'Guangdong Province',
        shantouLonghu: 'Longhu District, Shantou',
        songshanRoad: 'No. 235, Songshan North Road',
        hongkong: 'Hong Kong',
        wanchai: 'Wan Chai',
        queensRoad: 'No. 248, Queen\'s Road East',
        sunlightTower: '40/F, Dah Sing Financial Centre',
        secretary1: 'Yao Jiexi',
        secretary2: 'Huang Huiling',
        representative1: 'Yao Jiexi',
        representative2: 'Zheng Yuyan',
        foshanChancheng: 'Chancheng District, Foshan',
        foshanRoad: 'No. 65, Foshan Avenue North',
        queensRoad183: 'No. 183, Queen\'s Road East, Wan Chai',
        hopewellCentre: '17/F, Hopewell Centre',
        room1712: 'Rooms 1712-1716'
      },
      sections: {
        corporateGovernance: 'Corporate Governance',
        regulations: 'Regulations and Policies',
        antiCorruption: 'Anti-Corruption and Whistleblowing Policy and Procedures',
        reportingChannel: 'Reporting Channel'
      },
      actions: {
        read: 'Read',
        download: 'Download',
        loading: 'Loading...',
        noDocuments: 'No documents available'
      },
      communication: {
        intro: 'In accordance with the Rules Governing the Listing of Securities on The Stock Exchange of Hong Kong Limited, the Company has adopted arrangements for disseminating corporate communications in electronic form and provides and publishes corporate communications to shareholders of the Company on the Company\'s website ',
        and: ' and on the website of The Stock Exchange of Hong Kong Limited "HKEXnews" ',
        introEnd: '.',
        definition: '"Corporate Communications" refers to any document issued or to be issued by the Company for the information or action of holders of any of its securities, including but not limited to (a) the directors\' report, annual accounts together with a copy of the auditors\' report and, where applicable, summary financial report; (b) the interim report and, where applicable, summary interim report; (c) a notice of meeting; (d) a listing document; (e) a circular; and (f) a proxy form.',
        downloadNotice: 'The notification letter and reply form for registered shareholders and non-registered shareholders to select the means of receipt of corporate communications available for action and/or to request printed copies can be downloaded through the following links:',
        registeredLink: 'Notification Letter and Reply Form for Registered Shareholders on Arrangements for Disseminating Corporate Communications in Electronic Form',
        nonRegisteredLink: 'Notification Letter and Reply Form for Non-Registered Shareholders on Arrangements for Disseminating Corporate Communications in Electronic Form',
        hkexDownload: 'Shareholders may also download the above notification letter and reply form on the website of The Stock Exchange of Hong Kong Limited "HKEXnews".',
        emailNotice: 'If shareholders have provided their valid email addresses, they will receive corporate communications available for action by email each time the Company publishes such communications. If shareholders wish to receive printed copies of corporate communications, please complete and submit the above reply form to the Company\'s share registrar, or send an email to ',
        emailNoticeEnd: ', stating the shareholder\'s name, address and request to receive printed copies of corporate communications. Please note that the instruction to receive printed copies of future corporate communications will be valid for one year from the date of receipt of the shareholder\'s instruction and will expire thereafter.'
      }
    },
    stock: {
      service: 'Investor Service',
      listed: 'Listed on HKEX',
      marketCap: 'Market Cap',
      volume: 'Volume',
      loading: 'Loading...',
      open: 'Open',
      close: 'Prev Close',
      high: 'High',
      low: 'Low',
      yesterday: 'Prev Close',
      intraday: 'Intraday Chart',
      updateTime: 'Update Time',
      refresh: 'Refresh',
      tabs: {
        chart: 'Chart',
        detail: 'Detail'
      },
      bidAsk: {
        level: 'Level',
        bid: 'Bid',
        bidVolume: 'Bid Vol',
        ask: 'Ask',
        askVolume: 'Ask Vol',
        levelLabel: 'Bid{{level}}/Ask{{level}}'
      }
    }
  },

  // Contact Page
  contact: {
    hero: {
      title: 'Contact Us',
      subtitle: 'We look forward to communicating with you'
    },
    info: {
      title: 'Contact Information',
      addressLabel: 'Address: ',
      phoneLabel: 'Phone: ',
      postcodeLabel: 'Postcode: '
    },
    companies: [
      {
        nameCn: 'Charmacy Pharmaceutical Co., Ltd.',
        nameEn: 'Charmacy Pharmaceutical Co., Ltd.',
        address: 'No. 235, Songshan North Road, Longhu District, Shantou'
      },
      {
        nameCn: 'Guangdong Charmacy Pharmaceutical Co., Ltd.',
        nameEn: 'Guangdong Charmacy Pharmaceutical Co., Ltd.',
        address: 'No. 38 Fenjiang North Road, Zumiao Street, Chancheng District, Foshan, 1st Floor 11-14, 64-65, 4th Floor 79-103'
      },
      {
        nameCn: 'Zhuhai Chuangmei Hengxiang Pharmaceutical Co., Ltd.',
        nameEn: 'Zhuhai Chuangmei Hengxiang Pharmaceutical Co., Ltd.',
        address: '2nd Floor, Building 1, No. 919 Huawei Road, Xiangzhou District, Zhuhai'
      },
      {
        nameCn: 'Guangzhou Charmacy Pharmaceutical Co., Ltd.',
        nameEn: 'Guangzhou Charmacy Pharmaceutical Co., Ltd.',
        address: 'No. 33 Liyu Street, Dongchong Town, Nansha District, Guangzhou'
      },
      {
        nameCn: 'Huizhou Charmacy Pharmaceutical Co., Ltd.',
        nameEn: 'Huizhou Charmacy Pharmaceutical Co., Ltd.',
        address: 'Room 06, 4th Floor, Chuangxiang Building, Zhaitou, Luoyang Street, Boluo County'
      },
      {
        nameCn: 'Shenzhen Charmacy Pharmaceutical Co., Ltd.',
        nameEn: 'Shenzhen Charmacy Pharmaceutical Co., Ltd.',
        address: 'No. 8 Cichang Road, Baoan Community, Longgang District, Shenzhen, Charmacy Pharmaceutical'
      }
    ],
    financialPR: {
      title: 'Financial PR Company',
      nameCn: 'Wonderful Sky Financial Group Holdings Limited',
      nameEn: 'Wonderful Sky Financial Group Holdings Limited',
      addressLabel: 'Address: ',
      addressSz: 'Room 1412, Rongchao Economic and Trade Center, No. 4028 Jintian Road, Futian District, Shenzhen',
      hkAddressLabel: 'Hong Kong Principal Place of Business: ',
      addressHk: '9/F, Shui On Centre, 6-8 Harbour Road, Wanchai, Hong Kong'
    },
    feedback: {
      title: 'Complaints & Suggestions',
      subtitle: 'Please fill in the following information and we will contact you as soon as possible',
      name: 'Name',
      namePlaceholder: 'Please enter your name',
      nameRequired: 'Please enter your name',
      phone: 'Phone',
      phonePlaceholder: 'Please enter your phone number',
      phoneRequired: 'Please enter your phone number',
      phoneInvalid: 'Please enter a valid phone number',
      email: 'Email (Optional)',
      emailPlaceholder: 'Please enter your email',
      emailInvalid: 'Please enter a valid email address',
      category: 'Category',
      categoryPlaceholder: 'Please select a category',
      categoryRequired: 'Please select a category',
      categoryComplaint: 'Complaint',
      categorySuggestion: 'Suggestion',
      categoryCorruption: 'Corruption Report',
      subject: 'Subject',
      subjectPlaceholder: 'Please enter the subject',
      subjectRequired: 'Please enter the subject',
      message: 'Message',
      messagePlaceholder: 'Please enter your message',
      messageRequired: 'Please enter your message',
      submit: 'Submit',
      submitSuccess: 'Submitted successfully! We will contact you soon.',
      submitError: 'Submission failed, please try again later.'
    },
    shareholderCommunication: {
      title: 'Ways to Communicate with Shareholders'
    }
  },

  // 404 Page
  notFound: {
    title: 'Page Not Found',
    description: 'Sorry, the page you are looking for does not exist or has been removed.',
    backHome: 'Back to Home',
    goBack: 'Go Back'
  },

  // Common
  common: {
    admin: 'Admin',
    back: 'Back',
    backToList: 'Back to List',
    close: 'Close',
    languageSwitch: 'Language Switch',
    minutes: 'minutes',
    noData: 'No Data',
    selectLanguage: 'Select Language'
  },

  // SEO Configuration
  seo: {
    home: {
      title: 'Changmei Pharmaceutical - Creating Healthy and Beautiful Life',
      description: 'Changmei Pharmaceutical focuses on pharmaceutical distribution and health services, committed to creating healthy and beautiful life',
      keywords: 'Changmei Pharmaceutical,pharmaceutical distribution,health services,drug supply chain'
    },
    about: {
      title: 'About Us - Changmei Pharmaceutical',
      description: 'Learn about Changmei Pharmaceutical\'s history, corporate culture and core values',
      keywords: 'Changmei Pharmaceutical,company profile,corporate culture,history'
    },
    news: {
      title: 'Company News - Changmei Pharmaceutical',
      description: 'Stay informed about Changmei\'s latest developments and important events',
      keywords: 'Changmei Pharmaceutical,company news,industry news,corporate information'
    },
    careers: {
      title: 'Careers - Changmei Pharmaceutical',
      description: 'Join Changmei Pharmaceutical and create a better future together',
      keywords: 'Changmei Pharmaceutical,recruitment,positions,talent'
    },
    investor: {
      title: 'Investor Relations - Changmei Pharmaceutical',
      description: 'Changmei Pharmaceutical investor relations information',
      keywords: 'Changmei Pharmaceutical,investor relations,financial reports,corporate governance'
    },
    contact: {
      title: 'Contact Us - Changmei Pharmaceutical',
      description: 'Contact Changmei Pharmaceutical, we look forward to hearing from you',
      keywords: 'Changmei Pharmaceutical,contact,customer service'
    }
  }
};
